import { type IPersistentStorage } from '@webapp/infrastructure/interfaces/services/IPersistentStorage'

const STORAGE_KEY = 'procurify.guided-intake.promo-dismissed.v1'

interface StoredDismissal {
  isDismissed: boolean
}

interface Dependency {
  storage: IPersistentStorage
}

export class GuidedIntakePromoDismissalRepository {
  constructor(private readonly deps: Dependency) {}

  isDismissed(): boolean {
    return (
      this.deps.storage.get<StoredDismissal>(STORAGE_KEY)?.isDismissed ?? false
    )
  }

  dismiss(): void {
    this.deps.storage.set<StoredDismissal>(STORAGE_KEY, { isDismissed: true })
  }
}
